import { useTheme } from "styled-components";
import { HomeMainCatsCont } from "./taxonomy.styled";
import {
  classNames,
  labelHelper,
  trField,
  trHelper,
} from "helpers/themeHelpers";
import { linkToFind } from "helpers/links-builders/listing";
import IconLeftwardsArrow from "assets/icons/IconLeftwardsArrow";
import useGetCountry from "../../../../../../hooks/useGetCountry";
import useGetRouteCity from "../../../../../../hooks/useGetRouteCity";
import { isShobiddak } from "helpers/osHelpers";
import IconDownArrowHead from "assets/icons/IconDownArrowHead";
import { FC, useRef, useState } from "react";
import {
  EnumActionNameLevel1,
  EnumActionNameLevel2,
  EnumActionNameLevel3,
  EnumGeneratedBy,
  EnumUxTypes,
  EnumWidgets,
} from "../../../../../../libs/logging/types/loggingTypes";
import {
  ISendLoggingEventProps,
  sendLoggingEvent,
} from "../../../../../../libs/logging/helpers/sendLoggingEvent";
import Image from "../../../../../../componentReusable/Image";
import { IHome } from "../../../types/home";
import { gtmBannarCategory } from "GTMs/actions/homeActions";

interface IProps {
  homeData: IHome;
}

const HomeTaxonomy: FC<IProps> = ({ homeData }) => {
  const { translations, isSplashScreenHiding, isDesktop, isMobile } =
    useTheme();
  const [expanded, setExpanded] = useState(true);
  const country = useGetCountry();
  const city = useGetRouteCity();
  const homeCatsListRef = useRef(null);
  const taxonomies = homeData?.data?.taxonomy;
  const toggleHeight = () => {
    setExpanded(!expanded);
    if (!expanded && homeCatsListRef.current) {
      homeCatsListRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <HomeMainCatsCont
      id="homeMainCatsCont"
      {...classNames(
        isDesktop && "mt-32 mb-16",
        isMobile && "p-16 pt-8 mobileCardBorder"
      )}
      ref={homeCatsListRef}
    >
      <div
        {...classNames(
          isDesktop && "mb-32",
          isMobile && "mb-16",
          "flex flexSpaceBetween alignItems"
        )}
      >
        <h1 {...classNames(isMobile && "font-18", isDesktop && "font-26")}>
          {isShobiddak()
            ? translations.shobiddak_title
            : country.abbreviation == "ps"
            ? translations.openSooq_title_ps
            : trHelper(translations.openSooq_title, {
                __country__: city ? labelHelper(city) : labelHelper(country),
              })}
        </h1>
        <a
          href={linkToFind({ cities: [city] })}
          {...classNames(
            isMobile && "font-14",
            isDesktop && "font-24",
            "flex alignItems gap-10 bold"
          )}
          onClick={() => {
            sendLoggingEvent({
              actionNameLvl1: EnumActionNameLevel1.SEARCH,
              actionNameLvl2: EnumActionNameLevel2.TAXONOMY,
              actionNameLvl3: EnumActionNameLevel3.CLICK,
              currentWidgetName: EnumWidgets.CATEGORIES_LIST_ICON,
              ux_type: EnumUxTypes.NA,
              generatedBy: EnumGeneratedBy.USER,
              listingData: {
                city_name: city?.name_english,
              },
            } as ISendLoggingEventProps);
          }}
        >
          {translations.viewAll}
          {isDesktop && <IconLeftwardsArrow />}
        </a>
      </div>
      <div
        {...classNames(
          "mainCatsListWrapper flex flexWrap",
          isMobile && "overflowHidden gap-20 relative",
          isDesktop && "gap-10",
          isMobile && expanded && "setHeight pt-16"
        )}
      >
        {taxonomies?.items?.map((taxonomy, index) => {
          return (
            <a
              key={index}
              href={taxonomy?.weblink}
              onClick={() => gtmBannarCategory(taxonomy?.reporting_name)}
              {...classNames("center blackColor", isDesktop && "mb-16")}
            >
              <div
                {...classNames(
                  "homeCatImg grayBg p-8 mb-16 inline relative",
                  isMobile && "radius-8",
                  isDesktop && "fullRadius"
                )}
              >
                {taxonomy.tag_show &&
                  trField(taxonomy, "tag_label").length > 0 && (
                    <span className="absolute redBg whiteColor font-13 radius-8">
                      {trField(taxonomy, "tag_label")}
                    </span>
                  )}
                <Image
                  src={taxonomy.icon}
                  srcWebpFallback={taxonomy.icon}
                  alt={translations.Category + ": " + taxonomy.label}
                  width={isDesktop ? "60" : "48"}
                  height={isDesktop ? "53" : "48"}
                  loading={
                    isMobile && !isSplashScreenHiding
                      ? "lazy"
                      : isDesktop && index > 7
                      ? "lazy"
                      : "eager"
                  }
                />
              </div>
              <h2
                {...classNames(isDesktop && "font-15", isMobile && "font-13")}
              >
                {taxonomy.label}
              </h2>
            </a>
          );
        })}
        {isMobile && (
          <div
            {...classNames(
              expanded && "absolute beforeExpand",
              !expanded && "afterExpand"
            )}
          >
            <button
              {...classNames(
                "blueBtn flex alignItems font-12 gap-5 width-fit m-auto",
                expanded && "bounceEffect"
              )}
              onClick={toggleHeight}
            >
              {expanded ? translations.viewMore : translations.viewLess}
              <IconDownArrowHead fill="#fff" dataFlipTop={!expanded} />
            </button>
          </div>
        )}
      </div>
    </HomeMainCatsCont>
  );
};

export default HomeTaxonomy;
